import React, { Component } from "react";
import CIR_PayrollForm from "../CIR_PayrollForm/CIR_PayrollForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardPage
Description : Componente que contienen el formulario de la pantalla Card 
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente CardForm
================================================================================ */
class CIR_PayrollPage extends Component{
    render(){
        return(
            <div>                    
                <CIR_PayrollForm/>
            </div>
        )   
    }
}

export default CIR_PayrollPage;